import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./slices/userSlice";
import notificationsSlice from "./slices/notificationsSlice";
import ordersSlice from "./slices/ordersSlice";
import lookupSlice from "./slices/lookupSlice";
import regionSlice from "./slices/regionSlice";
import { thunk } from "redux-thunk";

export default configureStore({
  reducer: {
    user: userSlice,
    notifications: notificationsSlice,
    orders: ordersSlice,
    lookup: lookupSlice,
    region: regionSlice,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    thunk,
  ],
});
